import React from "react";
import { FiDownload } from "react-icons/fi";
import api from "../../services/api";
import { Button } from './ExportGestantesButton.styles';


const ExportGestantesButton = () => {
    const handleDownload = async () => {
        try {
            const response = await api.get("/relatorios/listar-gestantes-cadastradas-excel", {
                responseType: "blob"
            });

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "gestantes_cadastrados.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao baixar o arquivo:", error);
            alert("Erro ao baixar a lista de gestantes.");
        }
    };

    return (
        <Button
            onClick={handleDownload}
        >
            <FiDownload size={18} />
            Baixar Gestantes Cadastradas
        </Button>
    );
};

export default ExportGestantesButton;
